// extracted by mini-css-extract-plugin
export default {"header":"Table_header__QmPBy","link":"Table_link__q2UpJ","active":"Table_active__dNrKa","inactive":"Table_inactive__Vxz9k","td":"Table_td__9tHiQ","search":"Table_search__sf9ix"};